import { CommercialListControlAction } from './commercial-list.model';
import { ListEntity } from './model';

export function commercialListControlReducer(
  entity: ListEntity,
  controlAction: CommercialListControlAction,
): ListEntity {
  switch (controlAction.type) {
    case 'multiplier':
    case 'date-change':
      const clearedActions = (entity.commercialListControlActions ?? []).filter(
        (a) => a.type !== controlAction.type,
      );
      return {
        ...entity,
        commercialListControlActions: [...clearedActions, controlAction],
      };
    default:
      return entity;
  }
}
